import React, { useState, useContext, useEffect } from 'react';
import ShipmentHeader from './ShipmentHeader';
import GridShipmentCard from './GridShipmentCard';
import ShipmentCard2 from './ShipmentCard2';
import { DataContext } from '../contexts/DataContext';
import generateRandomShipments from '../utils/shipmentGenerator';
import logo from '../wisdom.png';

const ShipmentVisualizer = () => {
    const [view, setView] = useState('GridShipmentCard');
    const [filteredShipments, setFilteredShipments] = useState([]);
    const { shipments, fetchShipments } = useContext(DataContext);

    useEffect(() => {
        fetchShipments();
    }, [fetchShipments]);

    useEffect(() => {
        // Set filteredShipments to all shipments initially
        setFilteredShipments(shipments);
    }, [shipments]);  // This useEffect will update filteredShipments whenever shipments changes


    const handleSearch = (searchTerm) => {
        const filtered = shipments.filter(shipment => {
            return Object.values(shipment).some(value =>
                value && value.toString().toLowerCase().includes(searchTerm.toLowerCase())
            );
        });
        setFilteredShipments(filtered);
    }

    const handleFilterChange = (filters) => {
        const filtered = shipments.filter(shipment => {
            return Object.keys(filters).every(key => shipment[key] === filters[key]);
        });
        setFilteredShipments(filtered);
    }

    const handleToggleView = () => {
        setView(view === 'GridShipmentCard' ? 'ShipmentCard2' : 'GridShipmentCard');
    }

    return (
        <>
            <nav className="bg-white shadow px-6 py-4 w-full">
                <div className="flex justify-between items-center mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex">
                        <img src={logo} alt="Wisdom Logo" className="h-12" />
                    </div>
                    <div className="flex">
                        <span className="text-xl font-semibold text-gray-700">Shipment Visualizer</span>
                    </div>
                </div>
            </nav>
            <div className="shipment-visualizer bg-gray-100 min-h-screen p-6">
                <ShipmentHeader
                    shipments={shipments}
                    onSearch={handleSearch}
                    onFilterChange={handleFilterChange}
                    onToggleView={handleToggleView}
                />
                <div className={`shipment-cards-container grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-4 ${view === 'ShipmentCard2' ? 'xl:grid-cols-4' : 'xl:grid-cols-6'}`}>
                    {view === 'GridShipmentCard' &&
                        filteredShipments.map(shipment => (
                            <GridShipmentCard key={shipment.id} shipment={shipment} />
                        ))
                    }
                    {view === 'ShipmentCard2' &&
                        filteredShipments.map(shipment => (
                            <ShipmentCard2 key={shipment.id} shipment={shipment} />
                        ))
                    }
                </div>
            </div>
        </>
    );

}

export default ShipmentVisualizer;
